import { cn } from "@/lib/utils";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import * as Sentry from "@sentry/react";
import * as React from "react";
import { ErrorBoundary } from "react-error-boundary";

const Popover = PopoverPrimitive.Root;

const PopoverTrigger = PopoverPrimitive.Trigger;

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(({ className, align = "center", sideOffset = 4, ...props }, ref) => {
  return (
    <ErrorBoundary
      onError={(error, info) => {
        Sentry.captureException(error, {
          tags: { component: "Popover", area: "PopoverContent" },
          extra: {
            componentStack: info?.componentStack,
            dateISO: new Date().toISOString(),
          },
        });
      }}
      fallback={
        <h1 className="text-colorText text-center text-lg font-semibold px-4 flex items-center justify-center my-9">
          <div>
            Ocorreu um erro ao renderizar a aplicação (<strong>Popover</strong>
            ), possivelmente causado por alguma extensão do seu navegador.
            <br />
            <span className="text-primary block mt-2">
              Para utilizar a aplicação, recomendamos que você use uma guia
              anônima.
            </span>
          </div>
        </h1>
      }
    >
      <PopoverPrimitive.Portal>
        <PopoverPrimitive.Content
          ref={ref}
          align={align}
          sideOffset={sideOffset}
          className={cn(
            "z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none pointer-events-auto data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
            className
          )}
          {...props}
        />
      </PopoverPrimitive.Portal>
    </ErrorBoundary>
  );
});
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export { Popover, PopoverContent, PopoverTrigger };
